import $store from '../store'

// 解析权限数据为 { '/signing/initiate/upload': '合同签署/发起签约/合同上传' } 格式
function parseRoleMap(map, list, parentPath, parentNames) {
  if (!(list && list.length)) return

  list.forEach(item => {
    let path = (parentPath ? parentPath + '/' : '') + item.sign
    let names = (parentNames ? parentNames + '/' : '') + item.name
    let childs = item.children

    map[path] = names

    if (childs && childs.length) {
      parseRoleMap(map, childs, path, names)
    }
  })
}

// 解析用户权限数据
export function parseRoles(roles) {
  let map = {}
  parseRoleMap(map, roles)
  return map
}

// 是否拥有权限校验
export default function hasRole(role) {
  if (!role) return true

  let userRoles = $store.state.userRoles
  return !!userRoles[role]
}
